<template>
    <section>
        <div class="row">
            <div class="col px-5">
                
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb mt-5">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0 active" aria-current="page">
                            Mata Pelajaran Bahan Ajar
                        </li>
                    </ul>
                </nav>

                <div class="row mb-4" v-if="isComplexGrade">
                    <div class="col-12">
                        <div class="btn-group w-100 shadow-sm" role="group">
                            <button type="button" 
                                class="btn py-3 font-weight-bold" 
                                :class="activeTab === 'utbk' ? 'btn-danger' : 'btn-outline-danger'"
                                @click="activeTab = 'utbk'">
                                UTBK (SNBT)
                            </button>
                            <button type="button" 
                                class="btn py-3 font-weight-bold"
                                :class="activeTab === 'tka' ? 'btn-danger' : 'btn-outline-danger'"
                                @click="activeTab = 'tka'">
                                SAINTEK / SOSHUM
                            </button>
                            <button type="button" 
                                class="btn py-3 font-weight-bold"
                                :class="activeTab === 'mandiri' ? 'btn-danger' : 'btn-outline-danger'"
                                @click="activeTab = 'mandiri'">
                                UJIAN MANDIRI PTN
                            </button>
                        </div>
                    </div>
                </div>

                <div class="row">
                    
                    <div class="col-lg-9 col-12">
                        <div class="row">
                            <div class="col-xl-4 col-md-6 col-12 mb-4" v-for="gradeSubject in filteredMainSubjects" :key="gradeSubject.id">
                                
                                <div class="card border-danger position-relative">
                                    <div class="card border-danger position-absolute">
                                        <div class="card-body py-2 px-4">
                                            <h4 class="font-weight-bold mb-0 text-danger text-truncate text-center">
                                                {{ gradeSubject.subject.name }}
                                            </h4>
                                        </div>
                                    </div>
                                    
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col small py-3" v-html="gradeSubject.description"></div>
                                        </div>
                                        <div class="row justify-content-end">
                                            <div class="col-auto ml-auto">
                                                <router-link v-bind:to="{name: 'material/view', params: {id: gradeSubject.id}}" class="btn btn-sm btn-danger px-4 pull-right">
                                                    Masuk
                                                </router-link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="col-12 text-center py-5" v-if="filteredMainSubjects.length === 0">
                                <h5 class="text-muted">Materi belum tersedia untuk kategori ini.</h5>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-12">
                        
                        <div v-for="sidebarItem in sidebarSubjects" :key="sidebarItem.id" class="mb-4">
                            
                            <div class="card border-danger position-relative">
                                <div class="card border-danger position-absolute">
                                    <div class="card-body py-2 px-4">
                                        <h4 class="font-weight-bold mb-0 text-danger text-truncate text-center">
                                            {{ sidebarItem.subject.name }}
                                        </h4>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col small py-3" v-html="sidebarItem.description"></div>
                                    </div>
                                    <div class="row justify-content-end">
                                        <div class="col-auto ml-auto">
                                            <router-link v-bind:to="{name: 'material/view', params: {id: sidebarItem.id}}" class="btn btn-sm btn-danger px-4 pull-right">
                                                Masuk
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div> </div>
            </div>
        </div>

        <div class="row">
            <div class="col text-center mt-5">
                <Adsense v-bind:data-ad-client="googleAdsClientKey" data-ad-slot="8773918261"></Adsense>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "MaterialIndex",
        data() {
            return {
                gradeSubjects: [],
                googleAdsClientKey: process.env.GOOGLE_ADS_CLIENT,
                activeTab: 'tka', // Default Tab
                isComplexGrade: false // False = SMP, True = SMA/Alumni
            };
        },
        computed: {
            // 1. Sidebar Item: Try Out (69) & Seputar BTA (89)
            sidebarSubjects() {
                return this.gradeSubjects.filter(item => {
                    const sid = parseInt(item.subject.id);
                    return sid === 69 || sid === 89;
                }).sort((a, b) => {
                    // Urutkan ID 69 dulu baru 89
                    return parseInt(a.subject.id) - parseInt(b.subject.id);
                });
            },

            // 2. Main Content Item: Semua KECUALI ID 69 & 89
            mainContentSubjects() {
                return this.gradeSubjects.filter(item => {
                    const sid = parseInt(item.subject.id);
                    return sid !== 69 && sid !== 89;
                });
            },

            // 3. Filter & Sorting Custom
            filteredMainSubjects() {
                let subjects = [...this.mainContentSubjects]; // Copy array agar aman

                // === LOGIKA SMP (Sort Biasa) ===
                if (!this.isComplexGrade) {
                    return subjects.sort((a, b) => {
                        const nameA = a.subject.name.toLowerCase();
                        const nameB = b.subject.name.toLowerCase();
                        // TKA tetap prioritas di SMP
                        if (nameA.includes('tka') && !nameB.includes('tka')) return -1;
                        if (!nameA.includes('tka') && nameB.includes('tka')) return 1;
                        return 0;
                    });
                }

                // === LOGIKA SMA / ALUMNI (Custom Sort per Tab) ===
                if (this.activeTab === 'utbk') {
                    // Filter UTBK
                    let utbkSubjects = subjects.filter(item => {
                        const name = item.subject.name.toLowerCase();
                        return name.includes('penalaran') || name.includes('kuantitatif') || name.includes('literasi') || name.includes('pemahaman') || name.includes('potensi');
                    });

                    // Custom Sort UTBK: PU -> PPU/PBM -> PK -> PM -> LIT BIND -> LIT ENG
                    const order = [
                        'penalaran umum', 
                        'pengetahuan dan pemahaman umum', 
                        'pemahaman bacaan', 
                        'pengetahuan kuantitatif', 
                        'penalaran matematika', 
                        'literasi bahasa indonesia', 
                        'literasi bahasa inggris'
                    ];
                    
                    return this.sortByOrder(utbkSubjects, order);
                } 
                else if (this.activeTab === 'tka') {
                    // Filter SAINTEK / SOSHUM (Non-UTBK & Non-Mandiri)
                    let tkaSubjects = subjects.filter(item => {
                        const name = item.subject.name.toLowerCase();
                        const isUtbk = name.includes('penalaran') || name.includes('literasi') || name.includes('kuantitatif') || name.includes('potensi');
                        const isMandiri = name.includes('simak') || name.includes('ugm') || name.includes('utul') || name.includes('mandiri');
                        return !isUtbk && !isMandiri; 
                    });

                    // Custom Sort TKA: TKA -> IND -> ING -> MAT -> LANJUT -> FIS -> KIM -> BIO -> SEJ -> SOS -> GEO -> EKO -> ANT -> PKN
                    const order = [
                        'tka',
                        'bahasa indonesia',
                        'bahasa inggris',
                        'matematika',
                        'bahasa indonesia lanjut', 'bahasa indonesia tingkat lanjut',
                        'bahasa inggris lanjut', 'bahasa inggris tingkat lanjut',
                        'matematika lanjut', 'matematika tingkat lanjut',
                        'fisika',
                        'kimia',
                        'biologi',
                        'sejarah',
                        'sosiologi',
                        'geografi',
                        'ekonomi',
                        'antropologi',
                        'ppkn'
                    ];

                    return this.sortByOrder(tkaSubjects, order);
                } 
                else if (this.activeTab === 'mandiri') {
                    // Filter Mandiri
                    let mandiriSubjects = subjects.filter(item => {
                        const name = item.subject.name.toLowerCase();
                        return name.includes('simak') || name.includes('ugm') || name.includes('itb') || name.includes('mandiri');
                    });

                    // Custom Sort Mandiri: UI -> UGM -> ITB -> Lainnya
                    const order = ['ui', 'ugm', 'itb', 'lainnya'];
                    
                    return this.sortByOrder(mandiriSubjects, order);
                }

                return subjects;
            }
        },
        methods: {
            // Fungsi Helper untuk Custom Sorting
            sortByOrder(items, orderList) {
                return items.sort((a, b) => {
                    const nameA = a.subject.name.toLowerCase();
                    const nameB = b.subject.name.toLowerCase();

                    // Cari index posisi di daftar order
                    // findIndex akan mencari kata kunci pertama yang cocok
                    let indexA = orderList.findIndex(key => nameA.includes(key));
                    let indexB = orderList.findIndex(key => nameB.includes(key));

                    // Jika tidak ditemukan di daftar, taruh di paling belakang (999)
                    if (indexA === -1) indexA = 999;
                    if (indexB === -1) indexB = 999;

                    return indexA - indexB;
                });
            },
            
            checkGradeLevel(data) {
                // ID SMP/SD (Sesuai File ODS)
                const smpIds = [
                    1, 2, 3, 4, 5, 92, 117, 
                    144, 145, 146, 147, 148, 149, 150, 151, 152, 
                    188, 189, 190, 212
                ];

                const hasSmaSubject = data.some(item => {
                    const id = parseInt(item.id);
                    return !smpIds.includes(id);
                });

                this.isComplexGrade = hasSmaSubject;

                if (this.isComplexGrade) {
                    this.activeTab = 'utbk'; 
                } else {
                    this.activeTab = 'tka';
                }
            }
        },
        created() {
            this.axios.get(process.env.API_URL + '/grade-subject').then(response => {
                this.gradeSubjects = response.data.data;
                this.checkGradeLevel(this.gradeSubjects);
            });

            document.title = 'Materi Bahan Ajar - ' + process.env.APP_NAME;
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/material/Index.vue